<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X0w33q/tc-custom/9780226241708.jpg?1736606942649" alt="This image is the cover for the book Looking for The Stranger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Looking for The Stranger
      </h1>
      <p class="bookDescription body article font2">
        <b>A <i>New York Times</i> Notable Book. A literary exploration that is “surely destined to become the quintessential companion to Camus’s most enduring novel” (<i>PopMatters</i>).</b><br/>  <br/><i>The Stranger</i> is a rite of passage for readers around the world. Since its publication in France in 1942, Camus’s novel has been translated into sixty languages and sold more than six million copies. It’s the rare novel that’s as likely to be found in a teen’s backpack as in a graduate philosophy seminar. If the twentieth century produced a novel that could be called ubiquitous, <i>The Stranger</i> is it.<br/>  <br/> How did a young man in his twenties who had never written a novel turn out a masterpiece that still grips readers more than seventy years later? With <i>Looking for The Stranger</i>, Alice Kaplan tells that story. In the process, she reveals Camus’ achievement to have been even more impressive—and more unlikely—than even his most devoted readers knew.<br/>  <br/> “To this new project, Kaplan brings equally honed skills as a historian, literary critic, and biographer . . . Reading <i>The Stranger</i> is a bracing but somewhat bloodless experience. Ms. Kaplan has hung warm flesh on its steely bones.” —<i>The New York Times</i><br/>  <br/> “For American readers, few French novels are better known, and few scholars are better qualified than Kaplan to reintroduce us to it . . . Kaplan tells this story with great verve and insight, all the while preserving the mystery of its creation and elusiveness of its meaning.” —<i>Los Angeles Review of Books</i><br/>  <br/> “The fascinating story behind Albert Camus’ coldblooded masterpiece . . . A compelling companion to a novel that has stayed strange.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Kaplan
      </h2>
      
      <p class="authorDescription body article">Alice Kaplan is the author of numerous books, including Dreaming in French, The Interpreter, French Lessons, and The Collaborator, the last of which was a finalist for the National Book Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5956b738